import { Route, Routes } from 'react-router-dom'

import Analytics from './screens/Analytics'
import Overview from './screens/Overview'
import TasksList from './screens/TasksList'
import TaskDetail from './screens/TaskDetail'

interface ProjectDetailRoutesProps {
  taskListId: number,
}

const ProjectDetailRoutes = (props: ProjectDetailRoutesProps) => {
  const { taskListId } = props

  return (
    <Routes>
      <Route path="/analytics" element={<Analytics taskListId={taskListId} />} />
      <Route path="/edit" element={<Overview taskListId={taskListId} />} />
      <Route path="/tasks" element={<TasksList taskListId={taskListId} />} />
      <Route path="/tasks/:taskId/edit" element={<TaskDetail taskListId={taskListId} />} />
    </Routes>
  )
}

export default ProjectDetailRoutes
